/* 円山牛乳販売店 — Online Store */
(function () {
  'use strict';

  /* ---- homepage loader: 現行サイトと同じLottieアニメーション ---- */
  function loader() {
    var el = document.getElementById('MMLoader');
    if (!el) return;
    var animationTarget = document.getElementById('MMLottie');
    var complete = false;

    function reveal(removeImmediately) {
      if (complete) return;
      complete = true;
      if (removeImmediately) {
        document.body.classList.remove('mm-loading');
        el.remove();
        return;
      }
      el.classList.add('is-leaving');
      setTimeout(function () {
        document.body.classList.remove('mm-loading');
        if (el.parentNode) el.remove();
      }, 320);
    }

    function waitForHero() {
      var hero = document.querySelector('.mm-hero__media img');
      if (!hero) return Promise.resolve();
      return new Promise(function (resolve) {
        function ready() {
          if (hero.decode) hero.decode().then(resolve).catch(resolve);
          else resolve();
        }
        if (hero.complete && hero.naturalWidth) { ready(); return; }
        hero.addEventListener('load', ready, { once: true });
        hero.addEventListener('error', resolve, { once: true });
      });
    }

    var heroReady = waitForHero();
    function waitForHeroOrTimeout() {
      return Promise.race([
        heroReady,
        new Promise(function (resolve) { setTimeout(resolve, 2500); })
      ]);
    }

    try {
      if (sessionStorage.getItem('mm-loaded') === '1') {
        waitForHeroOrTimeout().then(function () { reveal(true); });
        return;
      }
    } catch (e) {}

    function finish() {
      if (complete) return;
      waitForHeroOrTimeout().then(function () {
        try { sessionStorage.setItem('mm-loaded', '1'); } catch (e) {}
        reveal(false);
      });
    }

    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !window.lottie || !animationTarget) {
      setTimeout(finish, 120);
      return;
    }

    try {
      var isIOS = /(iP(ad|hone|od)|CriOS)/.test(navigator.userAgent || '');
      var animation = window.lottie.loadAnimation({
        container: animationTarget,
        renderer: isIOS ? 'canvas' : 'svg',
        loop: false,
        autoplay: true,
        path: animationTarget.getAttribute('data-animation'),
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
          progressiveLoad: true
        }
      });
      animation.addEventListener('complete', finish);
      animation.addEventListener('data_failed', finish);
      setTimeout(finish, 7000);
    } catch (e) {
      setTimeout(finish, 120);
    }
  }

  /* ---- button logo: 現行サイトと同じホバーLottie ---- */
  function buttonLogos() {
    var staticLogo = document.body.getAttribute('data-mm-button-logo');
    var animationPath = document.body.getAttribute('data-mm-button-lottie');
    var canAnimate = window.lottie && animationPath
      && matchMedia('(hover: hover) and (pointer: fine)').matches
      && !matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.mm-btn').forEach(function (button) {
      if (button.getAttribute('data-mm-button-ready') === 'true') return;
      button.setAttribute('data-mm-button-ready', 'true');

      var label = document.createElement('span');
      label.className = 'mm-btn__label';
      while (button.firstChild) label.appendChild(button.firstChild);
      button.appendChild(label);

      var logo = document.createElement('span');
      logo.className = 'mm-btn__logo';
      logo.setAttribute('aria-hidden', 'true');
      var image = document.createElement('img');
      image.src = staticLogo;
      image.alt = '';
      var target = document.createElement('span');
      target.className = 'mm-btn__logo-lottie';
      logo.appendChild(image);
      logo.appendChild(target);
      button.appendChild(logo);

      if (!canAnimate) return;
      try {
        var animation = window.lottie.loadAnimation({
          container: target,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: animationPath
        });
        animation.addEventListener('DOMLoaded', function () {
          logo.classList.add('is-ready');
          animation.goToAndStop(0, true);
          button.addEventListener('mouseenter', function () {
            animation.setDirection(1);
            animation.play();
          });
          button.addEventListener('mouseleave', function () {
            animation.setDirection(-1);
            animation.play();
          });
        });
      } catch (e) {}
    });
  }

  /* ---- mobile drawer ---- */
  function drawer() {
    var d = document.getElementById('MMDrawer');
    if (!d) return;
    document.querySelectorAll('[data-mm-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = d.getAttribute('data-open') === 'true';
        d.setAttribute('data-open', String(!open));
        document.body.style.overflow = open ? '' : 'hidden';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.getAttribute('data-open') === 'true') {
        d.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---- accordion ---- */
  function accordion() {
    document.querySelectorAll('.mm-acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mm-acc__item');
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', String(!open));
        btn.setAttribute('aria-expanded', String(!open));
        var icon = btn.querySelector('i');
        if (icon) icon.textContent = open ? '＋' : '−';
      });
    });
  }

  /* ---- quantity stepper ---- */
  function quantity() {
    document.querySelectorAll('.mm-qty').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
          var configuredMin = parseInt(input.getAttribute('min'), 10);
          var min = Number.isNaN(configuredMin) ? 1 : configuredMin;
          input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- product gallery ---- */
  function gallery() {
    document.querySelectorAll('[data-mm-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-mm-gallery-main]') || root.querySelector('.mm-figure img');
      if (!main) return;
      var thumbs = root.querySelectorAll('[data-mm-gallery-thumb]');

      function preload(thumb, fullSize) {
        var source = thumb.getAttribute(fullSize ? 'data-src' : 'data-preload');
        if (!source || thumb.getAttribute(fullSize ? 'data-mm-preloaded-full' : 'data-mm-preloaded')) return;
        var image = new Image();
        image.src = source;
        thumb.setAttribute(fullSize ? 'data-mm-preloaded-full' : 'data-mm-preloaded', 'true');
      }

      thumbs.forEach(function (thumb) {
        if (thumb.getAttribute('aria-current') !== 'true') preload(thumb, false);
        thumb.addEventListener('pointerenter', function () { preload(thumb, true); });
        thumb.addEventListener('focus', function () { preload(thumb, true); });
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt');
          if (src) main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          else main.removeAttribute('srcset');
          if (alt) main.setAttribute('alt', alt);
          root.querySelectorAll('[data-mm-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', String(t === thumb));
          });
        });
      });
    });
  }

  /* ---- variant switching ---- */
  function variants() {
    document.querySelectorAll('[data-mm-variants]').forEach(function (form) {
      var data = form.querySelector('[data-mm-variant-json]');
      if (!data) return;
      var list = JSON.parse(data.textContent);
      var idField = form.querySelector('[data-mm-variant-id]');
      var price = form.parentElement.querySelector('[data-mm-price]');
      var submit = form.querySelector('[data-mm-submit]');
      var selects = form.querySelectorAll('[data-mm-option]');

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = list.filter(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        })[0];
        if (!match) return;
        if (idField) idField.value = match.id;
        if (price) {
          price.replaceChildren(document.createTextNode(match.price));
          var tax = document.createElement('small');
          tax.textContent = match.tax_included;
          price.appendChild(tax);
        }
        if (submit) {
          submit.disabled = !match.available;
          var submitLabel = submit.querySelector('.mm-btn__label');
          var submitText = match.available
            ? submit.getAttribute('data-label-add')
            : submit.getAttribute('data-label-sold');
          if (submitLabel) submitLabel.textContent = submitText;
          else submit.textContent = submitText;
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  /* ---- reveal on scroll ---- */
  function reveal() {
    var targets = document.querySelectorAll('[data-mm-reveal]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (t) { t.style.opacity = 1; });
      return;
    }
    targets.forEach(function (t) { t.style.opacity = 0; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '';
        entry.target.classList.add('mm-reveal');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    targets.forEach(function (t) { io.observe(t); });
  }

  function init() { loader(); buttonLogos(); drawer(); accordion(); quantity(); gallery(); variants(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
